import h from 'hyperscript';

import { formatDateTime } from '@disy/lib/format';

import { createResourceLabel } from 'ui/resource-label/resource-label';

import type { WorkbookVersionData } from 'cadenza/api-client/workbook-management-api';

import i18n from './workbook-version-cell-renderer.properties';

export function renderCommentCell(comment: string): Element | string {
  if (!(comment && comment.length)) {
    return '–';
  }
  return h('d-truncated-p', { fullText: comment });
}

export function renderWorkbookVersionCell(version: WorkbookVersionData, tr?: HTMLElement) {
  if (version.isCurrentState && tr) {
    tr.classList.add('d-workbook-versions--current-version');
  }

  const creationDate =
    version.creationDate ? formatDateTime(new Date(Date.parse(version.creationDate))) : i18n('unavailable-value');

  return h('.workbook-version-cell.d-stack-v.ellipsis', [
    h('.bold.ellipsis', determineVersionString(version)),
    h('.ellipsis', creationDate),
    createResourceLabel('user', version.userName?.printName || i18n('unavailable-value'), { styleClass: 'ellipsis' }),
  ]);
}

function determineVersionString(version: WorkbookVersionData): string {
  if (version.isUnsaved) {
    return i18n('current-state-unsaved');
  }

  if (version.isCurrentState && version.isChanged) {
    return i18n('current-state-changed', { version: version.version });
  }

  return `v${version.version}`;
}
